import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { DialogConfig } from '@rd/popup/dialog-config';
import { DialogRef } from '@rd/popup/dialog-ref';
import { PopupModule } from '@rd/popup/popup.module';
import { IconModule } from '@rd/shared-legacy/components/icon/icon.module';
import { OfferLocation } from '@rd/types';

@Component({
  standalone: true,
  imports: [CommonModule, IconModule, PopupModule, TranslateModule],
  selector: 'rd-offer-locations-dialog',
  templateUrl: './offer-locations-dialog.component.html',
  styleUrls: ['./offer-locations-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferLocationsDialogComponent {
  @HostBinding('class.rd-offer-locations-dialog') componentClass = true;

  constructor(
    private dialogRef: DialogRef,
    private dialogConfig: DialogConfig<{ locations: OfferLocation[] }>,
    private iconRegistryService: IconRegistryService,
  ) {
    this.registerIcons();
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('phone');
    this.iconRegistryService.registerIcon('close');
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  getLocations(): OfferLocation[] {
    return this.dialogConfig.data?.locations ?? [];
  }
}
